import Vue from "vue";
import Vuex from "vuex";
import swal from "sweetalert2";
import * as fb from "../firebase";
import router from "../router/index";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";

Vue.use(Vuex);

// realtime firebase
// fb.postsCollection.orderBy('createdOn', 'desc').onSnapshot(snapshot => {
//     let postsArray = []

//     snapshot.forEach(doc => {
//         let post = doc.data()
//         post.id = doc.id

//         postsArray.push(post)
//     })

//     store.commit('setPosts', postsArray)
// })

// fb.postsCollection.orderBy('createdOn', 'desc').onSnapshot(snapshot => {
//     let postsArray = []

//     snapshot.forEach(doc => {
//         let post = doc.data()
//         post.id = doc.id

//         postsArray.push(post)
//     })

//     store.commit('setPosts', postsArray)
// })

function catchAlert(title, e, type) {
    let msg = "";
    switch (e.code) {
        case "auth/invalid-email":
            msg = "Por favor captura un email válido";
            break;
        case "auth/wrong-password":
            msg = "Contraseña inválida";
            break;
        case "auth/too-many-requests":
            msg =
                "Demasiados intentos fallidos, intenta más tarde o recupera tu contraseña";
            break;
        case "auth/email-already-in-use":
            msg = "Este correo ya está dado de alta, recupera tu contraseña";
            break;
        case "auth/user-not-found":
            msg = "Este usuario no existe en nuestros registros, crea una cuenta";
            break;
        default:
            msg = "Hubo un error inesperado, por favor intenta de nuevo";
            break;
    }
    swal.fire(title, msg, type);
}

function sendAlert(title, msg, type) {
    swal.fire(title, msg, type);
}

function custom_sort(a, b) {
    return new Date(a.created_on.seconds) - new Date(b.created_on.seconds);
}

const store = new Vuex.Store({
    state: {
        loading: false,
        userProfile: {},
        posts: [],
        ticket: {
            id: null,
            puntos: null,
            time: null,
            time_txt: null,
            ini_time: null,
            fin_time: null,
        },
        tickets: [],
        pregs: [],
    },
    getters: {
        ticketID(state) {
            state.ticket.id = localStorage.getItem(
                "id_ultimo_ticket_veranocinepolis23"
            );
            return state.ticket.id;
        },
        timeInit(state) {
            state.ticket.ini_time = localStorage.getItem(
                "ticket_ini_time_veranocinepolis23"
            );
            return state.ticket.ini_time;
        },
        pregs(state) {
            state.pregs = JSON.parse(localStorage.getItem("pregs"));
            return state.pregs;
        },
    },
    mutations: {
        showLoader(state, val) {
            state.loading = val;
        },
        setUserProfile(state, val) {
            state.userProfile = val;
        },
        setPerformingRequest(state, val) {
            state.performingRequest = val;
        },
        setPosts(state, val) {
            state.posts = val;
        },
        setTicketID(state, val) {
            localStorage.setItem("id_ultimo_ticket_veranocinepolis23", val);
            state.ticket.id = val;
        },
        setTimeInit(state, val) {
            if (
                localStorage.getItem("ticket_ini_time_veranocinepolis23") == null ||
                localStorage.getItem("ticket_ini_time_veranocinepolis23") == ""
            ) {
                localStorage.setItem("ticket_ini_time_veranocinepolis23", val);
                state.ticket.ini_time = val;
            }
        },
        removeTimeInit(state, val = null) {
            localStorage.setItem("ticket_ini_time_veranocinepolis23", "");
            localStorage.setItem("pregs", "");
            state.ticket.ini_time = "";
        },
        setTicket(state, data) {
            state.ticket.puntos = data.puntos;
            state.ticket.time = data.time;
            state.ticket.time_txt = data.time_txt;
        },
        setTickets(state, data) {
            console.log("setting tickets");
            state.tickets = data;
        },
        setPregs(state, data) {
            if (
                localStorage.getItem("pregs") == null ||
                localStorage.getItem("pregs") == ""
            ) {
                localStorage.setItem("pregs", JSON.stringify(data));
                state.pregs = data;
            }
        },
    },
    actions: {
        async login({ dispatch }, form) {
            // sign user in

            dispatch("showLoader", true);
            let user = {};

            try {
                user = await fb.auth.signInWithEmailAndPassword(
                    form.email,
                    form.password
                );
                console.log(user.user);
            } catch (e) {
                console.log({ e: e });
                catchAlert("Oops", e, "warning");
            }

            dispatch("showLoader", false);

            if (
                Object.keys(user.user).length === 0 &&
                user.user.constructor === Object
            )
                return;

            //valida verificacion correo
            // // // console.log({ verified: user.user.emailVerified })
            // // // if (user.user.emailVerified == false) {
            // // //     sendAlert('Verifica tu correo', 'Aún no has verificado tu correo, ingresa al buzón del correo registrado y da clic en la liga de verificación.', 'warning')
            // // //     return
            // // // }

            // fetch user profile and set in state
            dispatch("fetchUserProfile", user.user);

            router.push("/dashboard");
            //router.push("/mis-participaciones");
        },
        async loginReportes({ dispatch }, form) {
            // // console.log('comenzó update de creation time')
            // // fb.functions.useFunctionsEmulator('http://localhost:5000')

            // // var updateCreationTime = fb.functions.httpsCallable('updateCreationTime');

            // // var data = {}
            // // await updateCreationTime(JSON.stringify(data)).then(function(result) {
            // //     // Read result of the Cloud Function.
            // //     console.log({ resultadoFire: result })
            // //         // ...
            // // });
            // // console.log('terminó update de creation time')

            // sign user in

            dispatch("showLoader", true);
            let user = {};

            try {
                user = await fb.auth.signInWithEmailAndPassword(
                    form.email,
                    form.password
                );
                console.log(user.user);
            } catch (e) {
                console.log({ e: e });
                catchAlert("Oops", e, "warning");
            }

            dispatch("showLoader", false);

            if (
                Object.keys(user.user).length === 0 &&
                user.user.constructor === Object
            )
                return;

            // fetch user profile and set in state
            dispatch("fetchUserProfile", user.user);

            router.push("/reportes/informe");
        },
        async signup({ dispatch, commit }, form) {
            // sign user up
            dispatch("showLoader", true);
            let user = {};
            try {
                user = await fb.auth.createUserWithEmailAndPassword(
                    form.email,
                    form.password
                );
                console.log(user.user);
            } catch (e) {
                console.log({ e: e });
                catchAlert("Oops", e, "warning");
                dispatch("showLoader", false);
            }

            // // if (Object.keys(user.user).length === 0 && user.user.constructor === Object)
            // //     return

            // create user object in userCollections

            let puntos_club_cinepolis = 0;
            if (form.club_cinepolis != '') {
                puntos_club_cinepolis = 3000;
            }

            await fb.usersCollection.doc(user.user.uid).set({
                user_id: user.user.uid,
                nombre: form.nombre,
                apellido: form.apellido,
                apellido2: form.apellido2,
                celular: form.celular,
                email: user.user.email,
                estado: form.estado,
                fecha_nacimiento: form.fecha_nacimiento,
                // puntos_acumulados: 0,
                // cupones_redimidos: 0,
                updated_at: "",
                club_cinepolis: form.club_cinepolis,
                puntos_club_cinepolis: puntos_club_cinepolis,
                entradas: form.entradas
            });

            //user.user.sendEmailVerification();

            // //commit('setUserProfile', {})
            // await fb.auth.signOut()
            ////dispatch("logout");
            router.push("/dashboard");
            // // clear user data from state
            // commit('setUserProfile', {})

            //sendAlert('¡Bien!', 'Hemos enviado un correo de verificación a la cuenta ' + form.email, 'success')
            dispatch("showLoader", false);

            // fetch user profile and set in state
            dispatch("fetchUserProfile", user.user);
        },
        async registroMonedero({ dispatch, commit }, monedero) {
            // sign user up
            dispatch("showLoader", true);

            const userId = fb.auth.currentUser.uid;

            await fb.usersCollection.doc(userId).update({
                monedero: monedero,
                updated_at: new Date(),
            });

            dispatch("fetchUserProfile", { uid: userId });

            dispatch("showLoader", false);

            sendAlert(
                "¡Bien!",
                "Se ha registrado correctamente tu monedero.",
                "success"
            );
            // fetch user profile and set in state
            //dispatch('fetchUserProfile', user.user)
        },
        async fetchUserProfile({ commit }, user) {
            // fetch user profile
            const userProfile = await fb.usersCollection.doc(user.uid).get();
            //console.log({ user: userProfile.data() })
            // set user profile in state
            commit("setUserProfile", userProfile.data());

            // change route to dashboard

            // if (router.currentRoute.path === '/login') {
            //     router.push('/')
            // }
        },
        async logout({ commit }) {
            // log user out
            await fb.auth.signOut();

            // clear user data from state
            commit("setUserProfile", {});

            // redirect to login view
            router.push("/login");
        },
        async logoutReportes({ commit }) {
            // log user out
            await fb.auth.signOut();

            // clear user data from state
            commit("setUserProfile", {});

            // redirect to login view
            router.push("/reportes");
        },
        async createPost({ state, commit }, post) {
            // create post in firebase
            await fb.postsCollection.add({
                createdOn: new Date(),
                content: post.content,
                userId: fb.auth.currentUser.uid,
                userName: state.userProfile.name,
                comments: 0,
                likes: 0,
            });
        },
        async likePost({ commit }, post) {
            const userId = fb.auth.currentUser.uid;
            const docId = `${userId}_${post.id}`;

            // check if user has liked post
            const doc = await fb.likesCollection.doc(docId).get();
            if (doc.exists) {
                return;
            }

            // create post
            await fb.likesCollection.doc(docId).set({
                postId: post.id,
                userId: userId,
            });

            // update post likes count
            fb.postsCollection.doc(post.id).update({
                likes: post.likesCount + 1,
            });
        },
        async updateProfile({ dispatch }, user) {
            const userId = fb.auth.currentUser.uid;
            // update user object
            const userRef = await fb.usersCollection.doc(userId).update({
                name: user.name,
                title: user.title,
            });

            dispatch("fetchUserProfile", { uid: userId });

            // update all posts by user
            const postDocs = await fb.postsCollection
                .where("userId", "==", userId)
                .get();
            postDocs.forEach((doc) => {
                fb.postsCollection.doc(doc.id).update({
                    userName: user.name,
                });
            });

            // update all comments by user
            const commentDocs = await fb.commentsCollection
                .where("userId", "==", userId)
                .get();
            commentDocs.forEach((doc) => {
                fb.commentsCollection.doc(doc.id).update({
                    userName: user.name,
                });
            });
        },
        async registraParticipacion({ dispatch, commit }, data) {
            dispatch("showLoader", true);

            //localStorage.setItem('puntos', puntos)
            //localStorage.setItem('ultimo_tiempo', data.time_txt)

            await dispatch("cierraParticipacion", {
                score: data.score,
                fecha_fin: new Date(),
                time_txt: data.time_txt,
                time: data.time,
                retos: data.retos,
            });

            commit("setTicketID", "");
            commit("removeTimeInit", "");

            dispatch("showLoader", false);

            console.log("redireccionando");

            router.push("/resultado");
        },
        async cierraParticipacion({ dispatch, commit }, data) {
            const userId = fb.auth.currentUser.uid;

            console.log({ "cierra participacion": this.getters.ticketID });
            //console.log(data)

            data.fecha_fin = new Date();
            data.ticketID = this.getters.ticketID;
            data.userId = fb.auth.currentUser.uid;

            //fb.functions.useFunctionsEmulator('http://localhost:5000')

            var cierraParticipacion = fb.functions.httpsCallable(
                "cierraParticipacion"
            );

            await cierraParticipacion(JSON.stringify(data)).then(function(result) {
                // Read result of the Cloud Function.
                console.log({ resultadoFire: result });
                // ...
            });
            console.log("terminó guardado cierra participación");

            //commit('setTicket', data)
        },
        async registroTicket({ dispatch, commit }, data) {
            //TODO: cerrar los tickets que estén en status abierto, antes de capturar nuevo ticket

            dispatch("showLoader", true);

            commit("removeTimeInit", "");

            const userId = fb.auth.currentUser.uid;

            console.log(data.file);

            let ticketImgUrl = await dispatch("uploadImage", data.file);

            // let img_membresia_frente = "";
            // let img_membresia_reves = "";

            // if (data.socio_plus == true) {
            //     img_membresia_frente = await dispatch("uploadImage", data.file2);
            //     img_membresia_reves = await dispatch("uploadImage", data.file3);
            // }

            //PROCESA TICKET EN VERYFI
            //let ticket_ocr = await dispatch("uploadVeryfi", ticketImgUrl);

            console.log("imagen cargada");
            console.log({ imgurl: ticketImgUrl });

            // let tokens_disponibles = Math.floor(
            //     parseInt(data.monto) / data.monto_minimo
            // );

            const time = new Date();
            let ticket_obj = {
                created_on: time,
                ticket_img_url: ticketImgUrl,
                // socio_plus: data.socio_plus,
                // no_membresia_plus: data.no_membresia_plus,
                // status_membresia: "por validar",
                // img_membresia_frente: img_membresia_frente,
                // img_membresia_reves: img_membresia_reves,
                user_id: fb.auth.currentUser.uid,
                user_email: fb.auth.currentUser.email,
                // monto: parseInt(data.monto),
                // tokens: tokens_disponibles,
                // tokens_disponibles: tokens_disponibles,
                no_ticket: "",
                // cadena: data.cadena,
                // status: "por validar",
                status: "valido",
                substatus: "",
                status_juego: "jugando",
                participaciones: [],
                ultimo_score: 0,
                no_ticket_veryfi: "",
                created_on_veryfi: "",
                cadena_veryfi: "",
                // coca_sin_azucar: "",
                ticket_ocr: "",
                mnms: ""
            };
            let ticket = await fb.ticketsCollection.add(ticket_obj);
            console.log({ ticket: ticket });

            console.log(ticket.id);
            commit("setTicketID", ticket.id);

            //guardar último ticket en usuario

            await fb.usersCollection.doc(userId).update({
                ultimo_ticket_registrado: ticket.id,
                ultimo_ticket_registrado_updated_at: time,
            });

            // // // dispatch("fetchUserProfile", { uid: userId });

            // // // dispatch("showLoader", false);

            // sendAlert('¡Bien!', 'Estamos validando tu ticket, recibirás notificación vía email cuando sea validado para poder participar en la dinámica. Recuerda conservar tus tickets de compra.', 'info')

            // // // router.push("/dinamica");

            ticket_obj.id = ticket.id;

            return ticket_obj;
        },
        async actualizaTicketVeryfi({ dispatch, commit }, data) {
            //TODO: cerrar los tickets que estén en status abierto, antes de capturar nuevo ticket

            console.log({ actualizandoveryfi: data.ticket_obj });

            const userId = fb.auth.currentUser.uid;

            // // // // // // let ticket_ocr = JSON.parse(data.ticket_ocr);
            let ticket_ocr = "";

            // let tokens_disponibles = 1;

            // if (data.validacion == "invalido") {
            //     tokens_disponibles = 0;
            // } else if (data.coca_sin_azucar === true) {
            //     tokens_disponibles++;
            // }

            // if (data.socio_plus === true) {
            //     tokens_disponibles = tokens_disponibles * 2;
            // }

            const time = new Date();

            let no_ticket = "NA";
            // // // // // // try {
            // // // // // //     //no_ticket = ticket_ocr.document_reference_number;
            // // // // // //     no_ticket = ticket_ocr.invoice_number;
            // // // // // // } catch (e) {
            // // // // // //     no_ticket = "NA";
            // // // // // // }

            let cadena = "NA";
            // // // // // // try {
            // // // // // //     cadena = ticket_ocr.vendor.raw_name;
            // // // // // // } catch (e) {
            // // // // // //     cadena = "NA";
            // // // // // // }

            let ticket = await fb.ticketsCollection.doc(data.ticket_obj.id).update({
                // tokens: tokens_disponibles,
                // tokens_disponibles: tokens_disponibles,
                no_ticket: no_ticket,
                no_ticket_veryfi: no_ticket,
                created_on_veryfi: time,
                cadena_veryfi: cadena,
                mnms: data.mnms,
                // coca_sin_azucar: data.coca_sin_azucar,
                // cashi: data.cashi,
                // // // // // // ticket_ocr: ticket_ocr,
                // // // // // // status: data.validacion,
                // // // // // // validacion_cinepolis: data.validacion_cinepolis,
                // // // // // // validacion_combo: data.validacion_combo,
                // // // // // // validacion_fecha: data.validacion_fecha,
                // // // // // // invoice_duplicado: data.invoice_duplicado,
            });

            dispatch("fetchUserProfile", { uid: userId });

            dispatch("showLoader", false);

            if (data.validacion == "valido") {
                // sendAlert('¡Ups!', 'El ticket que has registrado es inválido, verifica los datos de tu ticket e intenta subirlo de nuevo, la foto debe ser nítida y contener el ticket completo.', 'warning')
                if (data.coca_sin_azucar === true && data.cashi === true && data.socio_plus === true) {
                    return "cocacashiplus";
                } else if (data.coca_sin_azucar === true && data.cashi === true) {
                    return "cocacashi";
                } else if (data.coca_sin_azucar === true && data.socio_plus === true) {
                    return "cocasocioplus";
                } else if (data.socio_plus === true && data.cashi === true) {
                    return "sociopluscashi";
                } else if (data.coca_sin_azucar === true) {
                    return "coca";
                } else if (data.cashi === true) {
                    return "cashi";
                } else if (data.socio_plus === true) {
                    return "socioplus";
                } else {
                    return "ok";
                }
            } else if (data.validacion == "invalido") {
                //router.push("/dinamica");
                return "notok";
            }
        },
        // // // async uploadVeryfi({ dispatch }, img_url) {
        // // //     // File or Blob named mountains.jpg
        // // //     console.log("cargando imagen veryfi");

        // // //     const https = require("https");
        // // //     var qData = {
        // // //         file_name: "",
        // // //         file_data: "",
        // // //         file_url: "",
        // // //         file_urls: [img_url],
        // // //         categories: ["Grocery"],
        // // //         max_pages_to_process: 15,
        // // //         boost_mode: 0,
        // // //         auto_delete: 0,
        // // //         external_id: "123456789",
        // // //         async: 0,
        // // //         parse_address: 1,
        // // //     };
        // // //     this.$http
        // // //         .post(
        // // //             "https://api.veryfi.com/api/v7/partner/documents",
        // // //             JSON.stringify(qData), {
        // // //                 emulateJSON: true,
        // // //                 httpsAgent: new https.Agent({ rejectUnauthorized: false }),
        // // //                 headers: {
        // // //                     "Content-Type": "application/json",
        // // //                     "CLIENT-ID": "",
        // // //                     Authorization: "apikey :",
        // // //                 },
        // // //             }
        // // //         )
        // // //         .then(
        // // //             (response) => {
        // // //                 // get body data
        // // //                 console.log("VERYFI RESPONSE");
        // // //                 console.log(response);
        // // //                 return response;
        // // //             },
        // // //             (error) => {
        // // //                 // error callback
        // // //                 console.log("error callback");
        // // //                 console.log(error);
        // // //                 return { "error": error };
        // // //             }
        // // //         );
        // // // },

        async registraTrivia({ dispatch, commit }, data) {


            dispatch('showLoader', true)


            //localStorage.setItem('puntos', puntos)
            //localStorage.setItem('ultimo_tiempo', data.time_txt)

            await dispatch('cierraParticipacion', {
                puntos: data.puntos,
                fecha_fin: new Date(),
                time_txt: data.time_txt,
                time: data.time,
                respuestas: data.respuestas,
                week: moment().week(),
                beneficios: data.beneficios
            })

            commit('setTicketID', '')
            commit('removeTimeInit', '')

            dispatch('showLoader', false)

            console.log("redireccionando")

            router.push('/resultado')

        },


        async uploadImage({ dispatch }, file) {
            // File or Blob named mountains.jpg
            console.log("cargando imagen");
            const userId = fb.auth.currentUser.uid;
            const idImagen = uuidv4();
            const nombreImagen =
                userId + "-" + idImagen + "." + file.name.split(".").pop();

            const storageRef = fb.storage.ref(`tickets/${nombreImagen}`).put(file);

            let promesa = null;
            promesa = () => {
                return new Promise((resolve, reject) => {
                    storageRef.on(
                        "state_changed",
                        (snapshot) => {
                            //this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
                        },
                        (error) => {
                            console.log(error.message);
                            reject(error.message);
                        },
                        () => {
                            storageRef.snapshot.ref.getDownloadURL().then((url) => {
                                //console.log({ url: url })
                                resolve(url);
                                //this.picture =url;
                            });
                        }
                    );
                });
            };

            let downloadUrl = null;
            try {
                downloadUrl = await promesa();
            } catch (err) {
                console.log(err);
                return null;
            }

            console.log({ termino: downloadUrl });
            //dispatch('setImgUrl', downloadUrl)

            return downloadUrl;
        },
        showLoader({ commit }, val) {
            commit("showLoader", val);
        },
        async getTickets({ dispatch, commit }) {
            dispatch("showLoader", true);
            console.log("getTickets");

            const userId = fb.auth.currentUser.uid;
            let tickets = null;
            try {
                let promesa = null;
                promesa = () => {
                    return new Promise((resolve, reject) => {
                        fb.ticketsCollection
                            .where("user_id", "==", userId)
                            .where("status", "in", ["cerrado", "por validar"])
                            .onSnapshot((snapshot) => {
                                let postsArray = [];

                                snapshot.forEach((doc) => {
                                    let post = doc.data();
                                    post.id = doc.id;
                                    postsArray.push(post);
                                });

                                postsArray.sort(custom_sort);
                                console.log({ tickets_: postsArray });
                                store.commit("setTickets", postsArray);
                                resolve(postsArray);
                            });
                    });
                };

                tickets = await promesa();
                console.log("set already");
            } catch (err) {
                console.log(err);
            }

            dispatch("showLoader", false);
            return tickets;
        },
        async setTimeInit({ commit }) {
            const data = {
                init_time: new Date(),
                ticketID: this.getters.ticketID,
            };

            //fb.functions.useFunctionsEmulator('http://localhost:5000')
            var comienzaParticipacion = fb.functions.httpsCallable(
                "comienzaParticipacion"
            );

            let res = null;
            await comienzaParticipacion(JSON.stringify(data)).then(function(result) {
                // Read result of the Cloud Function.
                console.log({ resultadoFire: result });
                res = result;
                // ...
            });
            console.log("comienza participación");
            console.log(res);
            if (res.data.status == "notok" && res.data.time_init != "") {
                data.init_time = new Date(res.data.time_init);
            }

            commit("setTimeInit", data.init_time);
        },
        async revisarSemanaTicketsUsuario({ dispatch, commit }, data) {
            //TODO: cerrar los tickets que estén en status abierto, antes de capturar nuevo ticket

            dispatch("showLoader", true);

            const userId = data.userId;
            const ticketsSemana = await fb.ticketsCollection
                .where("user_id", "==", userId)
                .where("week", "==", moment().week())
                .where("status", "==", "cerrado")
                .get();

            let puntos_a_sumar = 100;

            console.log({ tickets_semana: ticketsSemana.length });

            if (ticketsSemana.length > 1) {
                puntos_a_sumar = 500;
            }

            dispatch("showLoader", false);

            return puntos_a_sumar;
        },
        async actualizarCodigoTicketDulceria({ dispatch, commit }, data) {
            //TODO: cerrar los tickets que estén en status abierto, antes de capturar nuevo ticket

            dispatch("showLoader", true);

            console.log({ actualizaTicket: data });

            const userId = data.userId;
            const ticketAbierto = await fb.ticketsCollection.doc(data.id).get();

            console.log(ticketAbierto);

            if (ticketAbierto.exists) {
                console.log({ ticketAbierto: ticketAbierto.data() });
                let ticket_data = ticketAbierto.data();
                let puntos_totales =
                    parseInt(ticket_data.puntos) + parseInt(data.puntos);

                await fb.ticketsCollection.doc(ticketAbierto.id).update({
                    codigo_updated_at: new Date(),
                    codigo_dulceria: data.codigo,
                    status: "cerrado",
                    tipo_cupon: data.tipo_cupon,
                    puntos_acumulados: parseInt(data.puntos),
                    puntos_totales: puntos_totales,
                });

                //acumular puntos para usuario
                // // // let user = await fb.usersCollection.doc(userId).get();
                // // // if (user.exists) {
                // // //     console.log({ user: user.data() })
                // // //     let user_data = user.data()
                // // //     let puntos_acumulados = parseInt(user_data.puntos_acumulados) + parseInt(data.puntos);

                // // //     await fb.usersCollection.doc(userId).update({
                // // //         puntos_acumulados: puntos_acumulados
                // // //     })

                // // // }
            } else {
                dispatch("showLoader", false);
                return false;
            }

            return true;
        },
        async changeStatusTicketValidacion({ dispatch, commit }, data) {
            //TODO: cerrar los tickets que estén en status abierto, antes de capturar nuevo ticket

            dispatch("showLoader", true);

            console.log({ actualizaTicket: data });

            await fb.ticketsCollection.doc(data.ticket_id).update({
                validacion_updated_at: new Date(),
                status: data.status,
            });

            dispatch("showLoader", false);

            return true;
        },

        async changeSubStatusTicketValidacion({ dispatch, commit }, data) {
            //TODO: cerrar los tickets que estén en status abierto, antes de capturar nuevo ticket

            dispatch("showLoader", true);

            console.log({ actualizaTicket: data });

            await fb.ticketsCollection.doc(data.ticket_id).update({
                validacion_substatus_updated_at: new Date(),
                substatus: data.status,
            });

            dispatch("showLoader", false);

            return true;
        },


        async changeStatusMembresiaValidacion({ dispatch, commit }, data) {
            //TODO: cerrar los tickets que estén en status abierto, antes de capturar nuevo ticket

            dispatch("showLoader", true);

            console.log({ actualizaTicket: data });

            let tokens = null;
            if (data.status == "valida") {

                const ticket = await fb.ticketsCollection.doc(data.ticket_id).get();

                console.log(ticket);

                if (ticket.exists) {
                    console.log({ ticketmembresia: ticket.data() });
                    let ticket_data = ticket.data();

                    //tokens = parseInt(ticket_data.tokens_disponibles) * 2;
                }

                await fb.ticketsCollection.doc(data.ticket_id).update({
                    validacion_updated_at: new Date(),
                    status_membresia: data.status,
                    //tokens_disponibles: tokens,
                });


            } else {

                await fb.ticketsCollection.doc(data.ticket_id).update({
                    validacion_updated_at: new Date(),
                    status_membresia: data.status,
                });


            }


            dispatch("showLoader", false);

            return true;
        },
        async actualizarCodigoNoValido({ dispatch, commit }, data) {
            //TODO: cerrar los tickets que estén en status abierto, antes de capturar nuevo ticket

            dispatch("showLoader", true);

            console.log({ actualizacodigonovalido: data });

            const userId = data.userId;
            const ticketAbierto = await fb.ticketsCollection.doc(data.id).get();

            console.log(ticketAbierto);

            if (ticketAbierto.exists) {
                console.log({ ticketAbierto: ticketAbierto.data() });
                let ticket_data = ticketAbierto.data();

                await fb.ticketsCollection.doc(ticketAbierto.id).update({
                    status: "cerrado",
                    tipo_cupon: data.tipo_cupon,
                    puntos_acumulados: 0,
                    puntos_totales: 0,
                });

                //acumular puntos para usuario
                let user = await fb.usersCollection.doc(userId).get();
                if (user.exists) {
                    console.log({ user: user.data() });
                    let user_data = user.data();
                    let puntos_acumulados =
                        parseInt(user_data.puntos_acumulados) + parseInt(data.puntos);

                    await fb.usersCollection.doc(userId).update({
                        puntos_acumulados: puntos_acumulados,
                    });
                }
            } else {
                dispatch("showLoader", false);
                return false;
            }

            return true;
        },
    },
});

export default store;